/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Reset_UnavailableInputs */

const en_error_mfa_reset_unavailable = /** @type {(inputs: Error_Mfa_Reset_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The approval of the resets is off: an administrator turns on the gate “Reset of the second factors of an external user”.`)
};

/**
* | output |
* | --- |
* | "The approval of the resets is off: an administrator turns on the gate “Reset of the second factors of an external user”." |
*
* @param {Error_Mfa_Reset_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_reset_unavailable = /** @type {((inputs?: Error_Mfa_Reset_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Reset_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_reset_unavailable(inputs)
});